import appActionTypes from '../constants/types'

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
  },
  filters: null,
  sorter: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.expert.get.requested:
    case appActionTypes.expert.create.requested:
    case appActionTypes.expert.delete.requested:
    case appActionTypes.expert.edit.requested:
    case appActionTypes.expert.get_all.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.expert.get.success:
      return {
        ...state,
        data: action.data?.docs,
        pagination: {
          ...state.pagination,
          page: action.data?.page,
          pageSize: action.data?.limit,
          total: action.data?.total,
        },
        sorter: action.data.sorter,
        filters: action.data.filters,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.expert.get_all.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.expert.create.success:
    case appActionTypes.expert.delete.success:
      return {
        ...state,
        data: action.data?.docs,
        pagination: {
          ...state.pagination,
          page: action.data?.page,
          pageSize: action.data?.limit,
          total: action.data?.total,
        },
        filters: null,
        sorter: null,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.expert.edit.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _list[index] = action.data

      return {
        ...state,
        data: _list,
        filters: null,
        sorter: null,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.expert.get.fail:
    case appActionTypes.expert.create.fail:
    case appActionTypes.expert.delete.fail:
    case appActionTypes.expert.edit.fail:
    case appActionTypes.expert.get_all.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      }
    case appActionTypes.expert.set.requested:
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    default:
      return state
  }
}
